<template>
  <UICard title="Dashboard export">
    <UICheckbox
      v-model="pdfExport"
      label="Enable PDF export"
    />
  </UICard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useSettingsStore } from '@/store/settings'

import { UICard } from '@ui/core'
import { UICheckbox } from '@ui/controllers'

const settingsStore = useSettingsStore()

const pdfExport = computed<boolean>({
  get() {
    return settingsStore.getPdfExport
  },
  set(value) {
    settingsStore.setPdfExport(value)
  },
})
</script>
